import { jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';
import toast from 'react-hot-toast';

async function getTree(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/theme-texts/getTree`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });

    return await response.json();
}

async function setAll(body, authHeaders) {
    const response = await fetch(`${API_URL}/p/theme-texts/setAll`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });

    return await response.json();
}

export default function useThemeTexts() {
    const { data, ...flags } = useAuthQuery({
        queryKey: ['theme-texts-tree'],
        queryFn: getTree,
        refetchOnWindowFocus: false
    });

    const saveAll = useAuthMutation({
        mutationFn: setAll,
        mutationKey: ['labels'],
        onSuccess: (res) => {
            res.ok ? toast.success(_t.intl.save()) : toast.error(res.errorText);
        },
        onError: () => console.error('Server Error')
    });

    return { data, flags, saveAll };
}
